import { NgxLoggerLevel } from 'ngx-logger';

export const environment = {
  production: true,
  clientVersion: '1.81.0-31-g83b21d9b',
  logLevel: NgxLoggerLevel.INFO,
  API_HOST: 'https://' + window.location.hostname
};
